import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=10318d27&scoped=true"
import script from "./PriceFilter.vue?vue&type=script&lang=ts"
export * from "./PriceFilter.vue?vue&type=script&lang=ts"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=10318d27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10318d27",
  null
  
)

export default component.exports